import React from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

const EmailSendManualDialog = ({
  open,
  bac,
  programName,
  triggerId,
  triggerOptions,
  programOptions,
  loadingTriggers = false,
  submitting = false,
  error = null,
  onBacChange,
  onProgramChange,
  onTriggerChange,
  onClose,
  onSubmit,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add email</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          <Typography variant="body2" color="text.secondary">
            This will force-send the selected trigger for the BAC/program and bypass dedupe.
          </Typography>
          {error && <Alert severity="error">{error}</Alert>}
          <TextField
            label="BAC"
            value={bac}
            onChange={(event) => onBacChange(event.target.value)}
            placeholder="123456"
            inputProps={{ inputMode: 'numeric' }}
            fullWidth
          />
          <FormControl fullWidth>
            <InputLabel id="manual-email-program-label">Program</InputLabel>
            <Select
              labelId="manual-email-program-label"
              label="Program"
              value={programName}
              onChange={(event) => onProgramChange(event.target.value)}
            >
              {programOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth disabled={!programName || loadingTriggers}>
            <InputLabel id="manual-email-trigger-label">Trigger</InputLabel>
            <Select
              labelId="manual-email-trigger-label"
              label="Trigger"
              value={triggerId}
              onChange={(event) => onTriggerChange(event.target.value)}
            >
              {triggerOptions.length === 0 && (
                <MenuItem value="" disabled>
                  {loadingTriggers ? 'Loading triggers…' : 'No triggers found'}
                </MenuItem>
              )}
              {triggerOptions.map((trigger) => (
                <MenuItem key={trigger.id} value={trigger.id}>
                  {trigger.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={onSubmit}
          disabled={submitting || !bac || !programName || !triggerId}
        >
          {submitting ? 'Sending…' : 'Send email'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EmailSendManualDialog;
